export const customerModalMixins = {
  methods: {
    openAppointmentModal: function(thisNode, args) {
      let timer = setTimeout(function checkCustomerEditorModals() {
        thisNode.$root.$children[0].showCustomerEditorModals = true;
        if (
          thisNode.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          let theContainer =
            thisNode.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.AppointmentModalId = args.id;
          theContainer.AppointmentModalStart = args.start;
          theContainer.AppointmentModalEnd = args.end;
          theContainer.AppointmentModalAllDay = args.allDay;
          theContainer.showAppointmentFormModal = true;
          timer = null;
        } else {
          timer = setTimeout(checkCustomerEditorModals, 200);
        }
      }, 200);
    }
  }
};
